

<template>
    <ul id="list-tasks">
      <li>
        <div id='oblea'>
          <div id='s1'>
            <img id="imagenPlaceholder" src="/dist/progress-item.gif"  v-show='imagenProducto == null'  style="width:40px; height:40px;" /> 
            <img id="imagenProducto" :src="imagenProducto" style="width: 50px" v-show='imagenProducto != null'/> 
          </div> 
          <div id='s2'>
            <p id='titulo'>{{item.Nombre}}</p>
            <p id='descrip'>{{item.Observacion}}</p>
            <span class='label'>Pedido Mínimo:</span> 
            <span class='value'>{{getPedidoMinimo}}</span>
            <span id='label-subtotal'>Pedido Máximo:</span>
            <span class='value'>{{getPedidoMaximo}}</span>
          </div> 
          <div id='s3'>   </div> 
        </div>
      </li>
    </ul>
  </template>
  
   
  <script>
    import axios from 'axios'
  
    
    export default {
      name: 'item-promocion',
      props: ['item'],
  
      data() {
        return {
          imagenProducto: null  
        }
      },  
  
      watch: {
        item: {
          immediate: true,
          handler  () {
            this.getImage()
          }
        }
      },

      computed: {
        getPrecioHabitual () {
          return this.item.PrecioHabitual.toFixed(2);
        },
        getPrecioPromocional () {
          return this.item.PrecioPromocional.toFixed(2);
        },

        getPedidoMinimo () {
          if (this.item.LimiteInferior > 0)
          {
            return this.item.LimiteInferior
          }
          else
          {
            return 'Sin limite'
          }          
        },

        getPedidoMaximo () {
          if (this.item.LimiteSuperior > 0)
          {
            return this.item.LimiteSuperior
          }
          else
          {
            return 'Sin limite'
          }

        }




      },
  
      methods: {

        getImage () {

          if (this.item.ArchivosId.length != 0)
          {
            var img = this.$store.state.pedido.imagenes.find( e => e.id === this.item.ArchivosId[0]);
            if (img != null)
            {
              this.imagenProducto = img.image
            } 
            else
            {
              let config = {
                  method: 'GET',
                  responseType: 'blob',
                  url:'/WebSalesArchivo?ArchivoId='+this.item.ArchivosId[0]+'&Ancho=150',
                  headers: {
                      Token:this.$store.state.user.token,
                      ClientSecret: process.env.CLIENT_SECRET,
                      EmpresaId: process.env.EMPRESA_ID
                  }
                }
                axios
                .request(config)
                .then(response => {
                  let reader = new FileReader()
                  reader.onload = () => {
                    this.imagenProducto = reader.result
                    var img = {id:this.item.ArchivosId[0],image:this.imagenProducto} 
                    this.$store.commit('pedido/saveImage',img)   
                  }
                  console.log(response.data)
                  reader.readAsDataURL(response.data)
                })
                .catch(err => console.log(err))
              }
            }
        }
      }
   
    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
 
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }


  #s1{
  width: 14%;
  height: 100%;
  background: #ffffff;  
  display: flex;
  justify-content: center;  
  align-items: center;  
  }


  #s2{
    width: 70%;
    height: 100%;
    background: #ffffff;  
  }
  
  #s3{
    width: 16%;
    height: 100%;
    background: #ffffff;  
    display: flex;
    justify-content: center;  
    align-items: center;  
  }
  
  #titulo{
    font-size: 14px;
    color: #656E76;
    margin-top: 8px;
    font-weight: 500;
  }
  
  #descrip{
    font-size: 9px;
    color: #656E76;
    height: 12px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  
  .label{
    font-size: 10px;
    color: #656E76;
    font-weight: bold;
    background-color: #ffffff;
    width: 85px;
    float: left;
  }
  
  .value{
    font-size: 10px;
    /*font-weight: bold;  */
    color: #656E76;
    width: 70px;
    background-color: #ffffff;
    float: left;
  }
  
  #label-subtotal{
    font-size: 10px;
    font-weight: bold;
    color: #656E76;
    margin-left: 10%;
    width: 90px;
    background-color: #ffffff;
    float: left;
  }

  
 </style>




// WEBPACK FOOTER //
// src/components/views/descuentos/itemDescuento.vue